// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*,
*::before,
*::after {
  box-sizing: border-box;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

.grading-accordion {
  border-radius: 5px;
  border: 1px solid #D1D3D4;
  margin: 10px 0;
}
.grading-accordion .acc-header {
  cursor: pointer;
  border-radius: 5px 5px 0px 0px;
  background-color: white;
  color: #0669B3;
  display: flex;
  font-size: 22px;
  font-weight: 600;
  justify-content: space-between;
  padding: 16px 24px;
}
.grading-accordion .acc-header .owner-name {
  margin-bottom: 0px;
}
.grading-accordion .acc-header.collapsed {
  border-radius: 5px;
}
.grading-accordion .acc-header.expanded {
  border-radius: 5px 5px 0 0;
}
.grading-accordion .accordion-body {
  padding: 16px 32px;
  background-color: white;
  border-top: 1px solid #A7A9AC;
  color: black;
}
.grading-accordion .accordion-body .accordion-btn-nav-wrapper {
  display: flex;
  justify-content: flex-end;
  margin: 16px -10px 16px 0px;
}
.grading-accordion .accordion-body .profile-comment-section {
  margin: 24px 0px;
}
.grading-accordion .accordion-body .profile-comment-section .profile-comment-input-wrapper {
  max-height: 0;
  opacity: 0;
  overflow: hidden;
  transition: max-height 0.2s ease-in-out, opacity 0.2s ease-in-out;
}
.grading-accordion .accordion-body .profile-comment-section .profile-comment-input-wrapper.show {
  max-height: 200px;
  opacity: 1;
}
.grading-accordion .accordion-body .profile-comment-section .profile-comment-input-wrapper.hide {
  max-height: 0;
  opacity: 0;
}
.grading-accordion .accordion-body .profile-comment-section .toggle-comment-btn {
  display: flex;
  gap: 8px;
  align-items: center;
  background-color: transparent;
  color: #0A4064;
  border: none;
  padding: 5px 10px;
  cursor: pointer;
  border-radius: 3px;
  margin-bottom: 5px;
  font-size: 0.85rem;
  text-decoration: underline;
  font-style: italic;
  margin-left: -10px;
}
.grading-accordion .accordion-body .profile-comment-section .toggle-comment-btn:hover {
  color: #1786DB;
}
.grading-accordion .accordion-body .profile-comment-section .profile-comment-textarea {
  border: 1px solid #A7A9AC;
  border-radius: 5px;
  font-size: 14px;
  min-height: 80px;
  padding: 5px;
  resize: vertical;
  width: 100%;
}
.grading-accordion .accordion-body .epr-subjects .subject-card {
  box-shadow: 0.1rem 0.15rem 0.3rem 0 #525151;
  padding: 16px 16px;
  background: #D1D3D4;
  margin-top: 32px;
  border-radius: 5px;
  min-height: 64px;
}
.grading-accordion .accordion-body .epr-subjects .subject-card .subject-header {
  display: flex;
  justify-content: space-between;
}
.grading-accordion .accordion-body .epr-subjects .subject-card .subject-header .teacher-epr-subject-name {
  color: #0A4064;
  font-size: 1.25rem;
  font-weight: 600;
}
.grading-accordion .accordion-body .epr-subjects .subject-card .subject-header .subject-header-right {
  display: flex;
}
.grading-accordion .accordion-body .epr-subjects .subject-card .subject-header .subject-header-right .placeholder-count {
  background-color: white;
  height: 34px;
  margin-right: 10px;
  padding: 4px 8px;
  min-width: 170px;
  border: 2px solid #FEBF31;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.grading-accordion .accordion-body .epr-subjects .subject-card .subject-header .subject-header-right .placeholder-count-done {
  background-color: white;
  height: 34px;
  margin-right: 10px;
  padding: 4px 8px;
  min-width: 170px;
  border: 2px solid green;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.grading-accordion .accordion-body .epr-subjects .subject-card .subject-header .subject-header-right .placeholder-not-started {
  background-color: white;
  height: 34px;
  margin-right: 10px;
  padding: 4px 8px;
  min-width: 170px;
  border: 2px solid #CB321A;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.grading-accordion .accordion-body .epr-subjects .subject-card .toggle-subject-comment-btn {
  background-color: transparent;
  color: #0A4064;
  border: none;
  padding: 0px;
  border-radius: 3px;
  font-size: 0.8rem;
  cursor: pointer;
}
.grading-accordion .accordion-body .epr-subjects .subject-card .toggle-subject-comment-btn i {
  margin-right: 6px;
}
.grading-accordion .accordion-body .epr-subjects .subject-card .toggle-subject-comment-btn:hover {
  color: #1786DB;
}
.grading-accordion .accordion-body .epr-subjects .subject-card .subject-comment-textarea {
  border: 1px solid #A7A9AC;
  border-radius: 5px;
  font-size: 14px;
  margin-top: 16px;
  min-height: 60px;
  padding: 5px;
  resize: vertical;
  width: 100%;
}
.grading-accordion .accordion-body .epr-group-section {
  margin: 0rem 3rem;
}
.grading-accordion .accordion-body .group-acc-wrapper {
  background-color: #D1D3D4;
  border-radius: 5px;
  padding: 16px 16px 1px 16px;
}
.grading-accordion .accordion-body .group-section-title {
  background: linear-gradient(to right, #c0def0 70%, #ffffff 100%);
  border-radius: 3px;
  color: #0A4064;
  font-size: 22px;
  font-weight: 600;
  margin: 2rem 0rem 1rem 0rem;
  padding: 8px 16px;
}`, "",{"version":3,"sources":["webpack://./src/styles/global/Colors.scss","webpack://./src/styles/GradingAccordion.scss","webpack://./src/styles/global/globalMixins.scss"],"names":[],"mappings":"AAAA;;;EAGI,sBAAA;ACCJ;;ADJA;;;EAGI,sBAAA;ACOJ;;AAPA;EACE,kBAAA;EACA,yBAAA;EACA,cAAA;AAUF;AARE;EACE,eAAA;EACA,8BAAA;EACA,uBAAA;EACA,cDoBS;ECnBT,aAAA;EACA,eAAA;EACA,gBAAA;EACA,8BAAA;EACA,kBAAA;AAUJ;AARI;EACE,kBAAA;AAUN;AALE;EACE,kBAAA;AAOJ;AAJE;EACE,0BAAA;AAMJ;AADE;EACE,kBAAA;EACA,uBAAA;EACA,6BAAA;EACA,YAAA;AAGJ;AADI;EACE,aAAA;EACA,yBAAA;EACA,2BAAA;AAGN;AAAI;EACE,gBAAA;AAEN;AAAM;EACE,aAAA;EACA,UAAA;EACA,gBAAA;EACA,iEAAA;AAER;AACM;EACE,iBAAA;EACA,UAAA;AACR;AAEM;EACE,aAAA;EACA,UAAA;AAAR;AAGM;EACE,aAAA;EACA,QAAA;EACA,mBAAA;EACA,6BAAA;EACA,cD/DE;ECgEF,YAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,0BAAA;EACA,kBAAA;EACA,kBAAA;AADR;AAGQ;EACE,cDnDS;ACkDnB;AAKM;EACE,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,WAAA;AAHR;AAQM;EC5EF,2CAAA;ED8EI,kBAAA;EACA,mBD7EA;EC8EA,gBAAA;EACA,kBAAA;EACA,gBAAA;AANR;AAQQ;EACE,aAAA;EACA,8BAAA;AANV;AAQU;EACE,cDxGF;ECyGE,kBAAA;EACA,gBAAA;AANZ;AASU;EACE,aAAA;AAPZ;AASY;EACE,uBAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAPd;AAUY;EACE,uBAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AARd;AAWY;EACE,uBAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AATd;AAcQ;EACE,6BAAA;EACA,cD3JA;EC4JA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;AAZV;AAcU;EACE,iBAAA;AAZZ;AAeU;EACE,cD/IO;ACkInB;AAiBQ;EACE,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,WAAA;AAfV;AAoBI;EACE,iBAAA;AAlBN;AAoBI;EACE,yBD3KE;EC4KF,kBAAA;EACA,2BAAA;AAlBN;AAoBI;EACE,gEAAA;EACA,kBAAA;EACA,cDnMI;ECoMJ,eAAA;EACA,gBAAA;EACA,2BAAA;EACA,iBAAA;AAlBN","sourcesContent":["*,\n*::before,\n*::after {\n    box-sizing: border-box;\n}\n// EPR colors\n// $dashboard-blue: #007bff; this color does not pass Accessibility. Updated version below.\n$dashboard-blue: #0d6efd;\n$dk-blue-toolbar: #19608f;\n$dk-blue: #0A4064;\n$lt-blue: #7DB7CC;\n$pale-blue: #c0def0;\n$information: #00AEEF;\n$information-hover: #02BFFF;\n$DCSD-logo-green: #84ae30;\n$text: #414042;\n$white: #EDEDED;\n$shadow: #525151;\n$red: #CB321A;\n$red-hover: #E2381D;\n$green: #C7CC68;\n\n$highlight: #FDF9D0;\n$important: #FEBF31;\n$lt-important: #FED883;\n$grey0: #EDf0F1;\n$grey1: #D1D3D4;\n$grey2: #A7A9AC;\n$grey3: #808080;\n$grey3a: #707070;\n$grey4: #636161;\n$grey4a: #444343;\n$pearl-blue: #0669B3;\n$pearl-blue-hover: #1786DB;\n$lt-pearl-blue: #63AEDE;\n$lt-pearl-blue-hover: #4589B3;\n\n$timeline-arrow-1: #718355;\n$timeline-arrow-2: #87986a;\n$timeline-arrow-3: #97a97c;\n$timeline-arrow-4: #b5c99a;\n$timeline-arrow-5: #cfe1b9;\n\n$permission-blue: #ADD8E6;\n$permission-green:#90EE90;\n$permission-orange: #FFA07A;\n","@import \"../styles/global/Colors\";\n@import \"../styles/global/globalMixins\";\n\n.grading-accordion {\n  border-radius: 5px;\n  border: 1px solid $grey1;\n  margin: 10px 0;\n\n  .acc-header {\n    cursor: pointer;\n    border-radius: 5px 5px 0px 0px;\n    background-color: white;\n    color: $pearl-blue;\n    display: flex;\n    font-size: 22px;\n    font-weight: 600;\n    justify-content: space-between;\n    padding: 16px 24px;\n\n    .owner-name {\n      margin-bottom: 0px;\n    }\n\n  }\n\n  .acc-header.collapsed {\n    border-radius: 5px;\n  }\n\n  .acc-header.expanded {\n    border-radius: 5px 5px 0 0;\n  }\n\n\n\n  .accordion-body {\n    padding: 16px 32px;\n    background-color: white;\n    border-top: 1px solid $grey2;\n    color: black;\n\n    .accordion-btn-nav-wrapper {\n      display: flex;\n      justify-content: flex-end;\n      margin: 16px -10px 16px 0px;\n    }\n\n    .profile-comment-section {\n      margin: 24px 0px;\n\n      .profile-comment-input-wrapper {\n        max-height: 0;\n        opacity: 0;\n        overflow: hidden;\n        transition: max-height 0.2s ease-in-out, opacity 0.2s ease-in-out;\n      }\n\n      .profile-comment-input-wrapper.show {\n        max-height: 200px;\n        opacity: 1;\n      }\n\n      .profile-comment-input-wrapper.hide {\n        max-height: 0;\n        opacity: 0;\n      }\n\n      .toggle-comment-btn {\n        display: flex;\n        gap: 8px;\n        align-items: center;\n        background-color: transparent;\n        color: $dk-blue;\n        border: none;\n        padding: 5px 10px;\n        cursor: pointer;\n        border-radius: 3px;\n        margin-bottom: 5px;\n        font-size: 0.85rem;\n        text-decoration: underline;\n        font-style: italic;\n        margin-left: -10px;\n\n        &:hover {\n          color: $pearl-blue-hover;\n        }\n      }\n\n      .profile-comment-textarea {\n        border: 1px solid $grey2;\n        border-radius: 5px;\n        font-size: 14px;\n        min-height: 80px;\n        padding: 5px;\n        resize: vertical;\n        width: 100%;\n      }\n    }\n\n    .epr-subjects {\n      .subject-card {\n        @include shadow();\n        padding: 16px 16px;\n        background: $grey1;\n        margin-top: 32px;\n        border-radius: 5px;\n        min-height: 64px;\n\n        .subject-header {\n          display: flex;\n          justify-content: space-between;\n\n          .teacher-epr-subject-name {\n            color: $dk-blue;\n            font-size: 1.25rem;\n            font-weight: 600;\n          }\n\n          .subject-header-right {\n            display: flex;\n\n            .placeholder-count {\n              background-color: white;\n              height: 34px;\n              margin-right: 10px;\n              padding: 4px 8px;\n              min-width: 170px;\n              border: 2px solid $important;\n              border-radius: 5px;\n              display: flex;\n              align-items: center;\n              justify-content: center;\n            }\n\n            .placeholder-count-done {\n              background-color: white;\n              height: 34px;\n              margin-right: 10px;\n              padding: 4px 8px;\n              min-width: 170px;\n              border: 2px solid green;\n              border-radius: 5px;\n              display: flex;\n              align-items: center;\n              justify-content: center;\n            }\n\n            .placeholder-not-started {\n              background-color: white;\n              height: 34px;\n              margin-right: 10px;\n              padding: 4px 8px;\n              min-width: 170px;\n              border: 2px solid $red;\n              border-radius: 5px;\n              display: flex;\n              align-items: center;\n              justify-content: center;\n            }\n          }\n        }\n\n        .toggle-subject-comment-btn {\n          background-color: transparent;\n          color: $dk-blue;\n          border: none;\n          padding: 0px;\n          border-radius: 3px;\n          font-size: 0.8rem;\n          cursor: pointer;\n\n          i {\n            margin-right: 6px;\n          }\n\n          &:hover {\n            color: $pearl-blue-hover;\n          }\n        }\n\n        .subject-comment-textarea {\n          border: 1px solid $grey2;\n          border-radius: 5px;\n          font-size: 14px;\n          margin-top: 16px;\n          min-height: 60px;\n          padding: 5px;\n          resize: vertical;\n          width: 100%;\n        }\n      }\n    }\n\n    .epr-group-section {\n      margin: 0rem 3rem;\n    }\n    .group-acc-wrapper {\n      background-color: $grey1;\n      border-radius: 5px;\n      padding: 16px 16px 1px 16px;\n    }\n    .group-section-title {\n      background: linear-gradient(to right, #c0def0 70%, #ffffff 100%);\n      border-radius: 3px;\n      color: $dk-blue;\n      font-size: 22px;\n      font-weight: 600;\n      margin: 2rem 0rem 1rem 0rem;\n      padding: 8px 16px;\n    }\n  }\n}\n","@import \"./Colors.scss\";\n\n@mixin borderRadius($radius: 5px) {\n    border-radius: $radius;\n}\n\n@mixin dialogueBold() {\n    font-weight: 600;\n    font-size: .9em;\n}\n\n@mixin input() {\n    border-radius: 5px;\n    font-weight: 400;\n    width: 100%;\n}\n\n@mixin infoRounded($radius) {\n    background: $information;\n    border-bottom-left-radius: $radius;\n    border-bottom-right-radius: $radius;\n}\n\n@mixin shadow() {\n    box-shadow: 0.1rem 0.15rem 0.3rem 0 $shadow;\n}\n@mixin shadowBottom() {\n    box-shadow: 0 0.1rem 0.15rem 0 $shadow;\n}\n@mixin standardInputContainer() {\n    font-weight: 500;\n    font-size: .9rem;\n    margin: 10px 0;\n}\n@mixin standardInput() {\n    @include borderRadius(5px);\n    border: none;\n    border: 1px solid $grey3;\n    padding: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
